import React from "react";
import "../../../../../assets/css/customer/components/LegalOptionModal.css";
import { AiOutlineClose } from "react-icons/ai";
import { FaShieldAlt, FaFileContract, FaChevronRight } from "react-icons/fa";

const LegalOptionsModal = ({ show, onClose, onSelectPrivacy, onSelectTerms }) => {
  if (!show) {
    return null;
  }

  return (
    <div className="legal-options-overlay" onClick={onClose}>
      <div className="legal-options-card" onClick={(e) => e.stopPropagation()}>
        <div className="legal-options-header">
          <h3 className="legal-options-title">Legal & Policies</h3>
          <button
            type="button"
            className="legal-options-close"
            onClick={onClose}
          >
            <AiOutlineClose size={16} />
          </button>
        </div>

        <div className="legal-options-body">
          <div className="legal-options-item" onClick={onSelectPrivacy}>
            <div className="legal-options-icon">
              <FaShieldAlt size={18} />
            </div>
            <div className="legal-options-text">
              <h4>Privacy Policy</h4>
              <p>How we collect and use your information</p>
            </div>
            <FaChevronRight className="legal-options-arrow" />
          </div>

          <div className="legal-options-item" onClick={onSelectTerms}>
            <div className="legal-options-icon">
              <FaFileContract size={18} />
            </div>
            <div className="legal-options-text">
              <h4>Terms & Conditions</h4>
              <p>Rules for using CraftHive</p>
            </div>
            <FaChevronRight className="legal-options-arrow" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default LegalOptionsModal;